import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Dialogmessage from '../../dialog';

import Loading from '../../loading';

class Add extends Component {

  state={
    load: false,
    message: '',
    error: '',
    dialogstatus: false,
    display: 'show',
    movementOption: '',
  }

  componentDidMount() {
    this.setMenus();
  }

  componentWillReceiveProps(props) {
    this.setMenus();
  }

  addCharacteristic() {
    let context = this;
    let partno = this.props.partno;
    let tax = document.getElementById('tax').value;
    let from_serial_no = document.getElementById('from_serial_no').value;
    let to_serial_no = document.getElementById('to_serial_no').value;
    let code = document.getElementById('code').value;
    let movement = this.state.movement;

    if(tax == '' || tax == null || tax == undefined) {
      context.setState({ error: 'Enter tax field!!!' })
      return;
    }

    if(from_serial_no == '' || from_serial_no == null || from_serial_no == undefined) {
      context.setState({ error: 'Enter From serial number field!!!' })
      return;
    }

    if(to_serial_no == '' || to_serial_no == null || to_serial_no == undefined) {
      context.setState({ error: 'Enter to serial number field!!!' })
      return;
    }

    if(code == '' || code == null || code == undefined) {
      context.setState({ error: 'Enter code field!!!' })
      return;
    }

    if (movement == '' || movement == null || movement == undefined) {
      context.setState({ error: 'Select Movement field!!!' })
      return;
    }

    context.setState({
      load: true,
      message: 'Spare Characteristics Adding!!!'
    });
    let data1 = {'partno': partno, 'tax': tax, 'from_serialno': from_serial_no,
                  'to_serialno': to_serial_no, 'hsn_code': code, 'movement': movement};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addcharacteristics.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          context.setState({
            load: false,
            display: 'none',
            error: '',
            dialogmessage: 'Characteristics added successfully!!!',
            dialogstatus: true,
          });
        }
        else {
          context.setState({
            load: false,
          });
          alert('Try again');
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  closedialog() {
    this.setState({
      dialogstatus: false
    })
  }

  clear() {
    document.getElementById("tax").value = "";
    document.getElementById("from_serial_no").value = "";
    document.getElementById("to_serial_no").value = "";
    document.getElementById("code").value = "";
  }

  setMenus() {
    let context = this;
    var x = [];
    let menu = ['Very Fast', 'Fast', 'Avarage', 'Slow'];
    menu.map((y) => {
      x.push({key: y, text: y, value: y});
    });
    try {
      context.setState({
        movementOption: x,
      });
    } catch (e) {}
  }

  onChange = (type) => (f, { value }) => {
    this.setState({ [type]: value })
  }

  render() {
    let { load, message, dialogmessage, dialogstatus, movement } = this.state;
    let loading, dialogs;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (dialogstatus) {
      dialogs = (<Dialogmessage message={dialogmessage} closedialog={this.closedialog.bind(this)} dialogstatus={dialogstatus} />)
    }
    return (
      <div style={{padding: '1%'}}>
        <Card fluid>
          <Grid style={{padding: '1%'}}>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              Tax<br/>
              <Input type="number" focus placeholder='Tax' id='tax' style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              From-Serial-No<br/>
              <Input type="number" focus placeholder='From-Serial-No' id='from_serial_no' style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              To-Serial-No<br/>
              <Input type="number" focus placeholder='To-Serial-No' id='to_serial_no' style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              HSN-CODE<br/>
              <Input type="number" focus placeholder='HSN-CODE' id='code' style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              Movement<br/>
              <Dropdown fluid
                id="Movement" onChange={this.onChange('movement')}
                search selection options={this.state.movementOption}
                value={movement} fluid style={{ borderColor: '#5A9CBB' }} />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <center><div style={{color: 'red', fontSize: 13, fontWeight: 'bold'}}>{this.state.error}</div></center>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8} style={{display: this.state.display}}>
              <Button fluid onClick={this.clear.bind(this)}>Clear</Button>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8} style={{display: this.state.display}}>
              <Button fluid positive onClick={this.addCharacteristic.bind(this)}>Save</Button>
            </Grid.Column>
          </Grid>
        </Card>
        {loading}
        {dialogs}
      </div>
    );
  }
}

export default Add;
